import { LuText } from "react-icons/lu";
import { motion } from "motion/react";
import { UseFormRegister, FieldErrors } from "react-hook-form";
import { ActivityFormValues } from "../../zod/activitySchema";
import { XMarkIcon } from "@heroicons/react/24/outline";

interface DescriptionSectionProps {
  register: UseFormRegister<ActivityFormValues>;
  errors: FieldErrors<ActivityFormValues>;
  displayDescription: boolean;
  setDisplayDescription: (display: boolean) => void;
}

export default function DescriptionSection({
  register,
  errors,
  displayDescription,
  setDisplayDescription,
}: DescriptionSectionProps) {
  return displayDescription ? (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 10 }}
      transition={{ duration: 0.3 }}
      className="border border-tertiary/20 rounded-md p-4"
    >
      <div className="flex items-center gap-4 mb-1">
        <label htmlFor="description" className="block text-sm font-medium">
          Description
        </label>
        <XMarkIcon
          className="text-muted h-4 w-4 cursor-pointer hover:opacity-80"
          onClick={() => setDisplayDescription(false)}
        />
      </div>
      <textarea
        id="description"
        {...register("description")}
        rows={3}
        className="w-full p-2 rounded-md bg-input focus:outline-none focus:ring-2 focus:ring-card border border-border"
        placeholder="Description"
      />
      {errors.description && (
        <p className="text-tertiary text-sm mt-1">
          {errors.description.message}
        </p>
      )}
    </motion.div>
  ) : (
    <div
      className="flex items-center gap-2 cursor-pointer text-secondary hover:text-primary/80 transition-all duration-300"
      onClick={() => setDisplayDescription(true)}
    >
      <LuText className="w-4 h-4" />
      Ajouter une <span className="underline">description</span>
    </div>
  );
}
